<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
    <Header />

    <div class="container">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <SecondHeader />
        </div>
      </div>
      <div class="row">
        <div class="col-md-12" v-if="this.experiences.imagesLink.length > 0">
          <p class="title_second_experiencie">Imágenes</p>
          <br />
          <carousel :per-page="3" paginationActiveColor="#3366CC" id="carousel_noticias">
            <slide v-for="(exp, index) in this.experiences.imagesLink" :key="index">
              <div class="row">
                <div class="col-md-10 col-sm-12">
                  <div class="card mb-3">
                    <div class="row no-gutters">
                      <div class="col-md-12">
                        <img
                          class="card-img"
                          alt="imagenes"
                          style="opacity: 0.9: object-fit: cover"
                          :src="exp"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </slide>
          </carousel>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-sm-12" v-if="this.experiences.code">
          <div class="container_items">
            <p class="title_second_experiencie">Código</p>
            <p
              class="result_second_experience"
            >{{this.experiences.code ? this.experiences.code : ""}}</p>
          </div>
        </div>
        <div class="col-md-12 col-sm-12" v-if="this.experiences.locationDepartments">
          <div class="container_items">
            <p class="title_second_experiencie">Ubicación</p>
            <p
              class="result_second_experience"
            >{{this.experiences.locationDepartments ? this.experiences.locationDepartments.department : ""}} / {{this.experiences.locationMunicipalities ? this.experiences.locationMunicipalities.municipality : ""}}</p>
          </div>
        </div>
        <div class="col-md-12 col-sm-12" v-if="this.experiences.longName">
          <div class="container_items">
            <p class="title_second_experiencie">Nombre</p>
            <p class="result_second_experience">{{ this.experiences.longName }}</p>
          </div>
        </div>
        <div v-if="this.guild" class="col-md-12 col-sm-12">
          <div class="container_items">
            <p class="title_second_experiencie">Gremio</p>
            <ul>
              <li v-for="(obj, index) in guild" :key="index">{{obj}}</li>
            </ul>
          </div>
        </div>
        <div class="col-md-12 col-sm-12" v-if="queryLevel.length > 0">
          <div class="container_items">
            <p class="title_second_experiencie">Nivel y subnivel de Adaptación</p>
            <ul>
              <li v-for="(obj, index) in queryLevel" :key="index">{{obj}}</li>
            </ul>
          </div>
        </div>
        <div class="col-md-12 col-sm-12" v-if="this.experiences.measure">
          <div class="container_items">
            <p class="title_second_experiencie">Medida individual o conjunto de medidas.</p>
            <p class="result_second_experience">{{this.experiences.measure}}</p>
          </div>
        </div>
        <div class="col-md-12 col-sm-12" v-if="this.experiences.responsableName">
          <div class="container_items">
            <p class="title_second_experiencie">Datos de contacto</p>
            <p
              class="result_second_experience"
            >{{this.experiences.responsableName}} / {{this.experiences.responsableMail}} / {{this.experiences.responsablePhone}}</p>
          </div>
        </div>
        <div class="col-md-12 col-sm-12" v-if="this.experiences.projectText">
          <div class="container_items">
            <p class="title_second_experiencie">Proyecto o estrategia en la que se enmarca</p>
            <div class="result_second_experience">
              <p>{{this.experiences.projectText}}</p>
            </div>
          </div>
        </div>

        <div class="col-md-12 col-sm-12" v-if="this.experiences.longName">
          <div class="container_items">
            <p class="title_second_experiencie">Nombre largo</p>
            <div class="result_second_experience">
              <p>{{this.experiences.longName}}</p>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12" v-if="queryObjetive">
          <div class="container_items">
            <p v-if="queryObjetive.length > 0"
              class="title_second_experiencie"
            >Objetivo de desarrollo sostenible (ODS) y metas a las que contribuye</p>
            <div class="result_second_experience">
              <ul>
                <li
                  v-for="(obj, index) in queryObjetive"
                  :key="index"
                >{{obj.descObj ?obj.descObj : obj.nameObj }}</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12" v-if="this.experiences.indicatorText">
          <div class="container_items">
            <p
              class="title_second_experiencie"
            >Indicador(es) global(es) de los ODS al que contribuye</p>
            <div class="result_second_experience">
              <p>{{this.experiences.indicatorText}}</p>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12" v-if="queryThreat.length > 0">
          <div class="container_items">
            <p class="title_second_experiencie">Amenazas</p>
            <div class="result_second_experience">
              <ul>
                <li v-for="(obj, i) in queryThreat" :key="i">{{obj}}</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="col-md-12 col-sm-12" v-if="experiences.vulnerability">
          <div class="container_items">
            <p
              class="title_second_experiencie"
            >Vulnerabilidad identificada a las amenazas meteorológicas</p>
            <div class="result_second_experience">
              <p>{{this.experiences.vulnerability}}</p>
            </div>
          </div>
        </div>

        <div class="col-md-12 col-sm-12" v-if="this.experiences.entityText">
          <div class="container_items">
            <p class="title_second_experiencie">Organizaciones, entidades y comunidades involucradas</p>
            <div class="result_second_experience">
              <p>{{this.experiences.entityText}}</p>
            </div>
          </div>
        </div>

        <div class="col-md-12 col-sm-12" v-if="this.experiences.measureDescription">
          <div class="container_items">
            <p class="title_second_experiencie">Descripción de la medida</p>
            <div class="result_second_experience">
              <p>{{this.experiences.measureDescription}}</p>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12" v-if="this.experiences.measureCostValue">
          <div class="container_items">
            <p class="title_second_experiencie">Costo de medida</p>
            <div class="result_second_experience">
              <p>{{this.experiences.measureCostValue}}</p>
            </div>
          </div>
        </div>

        <div class="col-md-12 col-sm-12" v-if="this.experiences.measureResult">
          <div class="container_items">
            <p class="title_second_experiencie">Resultados de la implementación de la medida</p>
            <div class="result_second_experience">
              <p>{{this.experiences.measureResult}}</p>
            </div>
          </div>
        </div>

        <div class="col-md-12 col-sm-12" v-if="this.experiences.beneficiary">
          <div class="container_items">
            <p class="title_second_experiencie">Beneficiarios directos e indirectos</p>
            <div class="result_second_experience">
              <p>{{this.experiences.beneficiary}}</p>
            </div>
          </div>
        </div>

        <div class="col-md-12 col-sm-12" v-if="this.experiences.successFactor">
          <div class="container_items">
            <p class="title_second_experiencie">Factores de éxito</p>
            <div
              class="result_second_experience"
              style="white-space: pre-wrap; 
              word-wrap: break-word;
              font-family: inherit;"
            >
              <span>{{this.experiences.successFactor}}</span>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12" v-if="this.experiences.responsableName">
          <div class="container_items">
            <p class="title_second_experiencie">Nombre responsable</p>
            <div class="result_second_experience">
              <p>{{this.experiences.responsableName}}</p>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12" v-if="this.experiences.responsableCharge">
          <div class="container_items">
            <p class="title_second_experiencie">Cargo responsable</p>
            <div class="result_second_experience">
              <p>{{this.experiences.responsableCharge}}</p>
            </div>
          </div>
        </div>

        <div class="col-md-12 col-sm-12" v-if="this.experiences.responsablePhone">
          <div class="container_items">
            <p class="title_second_experiencie">Numero teléfono responsable</p>
            <div class="result_second_experience">
              <p>{{this.experiences.responsablePhone}}</p>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-sm-12" v-if="this.experiences.externalLink">
          <div class="container_items">
            <p v-if="this.getExternalLinks.length > 0" class="title_second_experiencie">Links</p>
            <div class="result_second_experience">
              <ul>
                <li v-for="(obj,index) in this.getExternalLinks" :key="index">
                  <a v-if="obj" :href="obj">Link {{index + 1}}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-12" v-if="this.experiences.filesLink.length > 0">
          <div class="container_items">
            <p class="title_second_experiencie">Anexos</p>
            <div class="result_second_experience">
              <ul>
                <li v-for="(obj,index) in this.experiences.filesLink" :key="index">
                  <a :href="obj">{{ lastFileName(obj) }}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>


<script>
import Header from "./partials/Header";
import Footer from "./partials/Footer";
import Mapa from "./partials/Mapa";
import HeaderResponsive from "./partials/HeaderResponsive";
import SecondHeader from "./partials/SecondHeader";

import axios from "axios";

import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
import config from "../../helpers/config";
import fileName from "../../helpers/fileName";

export default {
  components: {
    Header,
    HeaderResponsive,
    Footer,
    Mapa,
    Loading,
    SecondHeader
  },
  mounted() {
    this.getExperiences(this.$router.history.current.query.user_id);
  },
  data() {
    return {
      experiences: [],
      queryObjetive: [],
      queryLevel: [],
      queryThreat: [],
      link_1: "",
      link_2: "",
      isLoading: false,
      fullPage: true,
      index_view: true,
      detail_view: false,
      code: null,
      departament: null,
      municipality: null,
      name: null,
      longName: null,
      guild: null,
      adaptation: null,
      sub_adaptation: null,
      measure: null,
      responsible_name: null,
      responsible_email: null,
      responsible_phone: null,
      responsible_charge: null
    };
  },
  methods: {
    lastFileName(name) {
      return fileName(name);
    },
    onMapClick: function(attr) {
      console.log({
        group: "map",
        title: "State clicked",
        text: `You clicked on state with id: ${attr.mapId} and title: ${attr.title}`
      });
    },

    navigation(experience) {},
    navigation_back() {
      this.index_view = true;
      this.detail_view = false;
    },
    getExperiences(id) {
      const vue = this;
      this.isLoading = true;
      axios
        .get(
          `${config.urlApi}/experiences/${id}?filter[include]=locationDepartments&filter[include]=locationMunicipalities&filter[where][expStatusId]=1`,
          {}
        )
        .then(({ data }) => {
          this.experiences = data;
          this.isLoading = false;
          return data;
          //PROBLEMA CON TRAERSE LOS FILES, NO SE SEPARARON LAS IMAGENES DE LOS ANEXOS
          //Y POR LO MENOS UNA IMAGEN POR EXPERIENCIA DEBE SUBIRSE
        })
        .then(data => {
          const {
            guildId,
            objIds,
            adaptSubIds,
            adaptIds,
            threatIds,
            threatSubIds,
            guildIds
          } = data;
          function getGuild() {

            if (guildIds.length === 0)
              return ;

            const queryAdap = guildIds
              .map((item, index) => {
                return `&filter[where][or][${index}][id]=${item}`;
              })
              .join();
            return axios.get(`${config.urlApi}/guilds?${queryAdap}`);
          }

          function getObjetive() {

            if (objIds.length === 0)
              return ;

            const queryObj = objIds
              .map((item, index) => {
                return `&filter[where][or][${index}][id]=${item}`;
              })
              .join();
            return axios.get(`${config.urlApi}/objectives?${queryObj}`);
          }
          function getAdaptLevelParent() {

            if (adaptIds.length === 0)
              return ;

            const queryAdap = adaptIds
              .map((item, index) => {
                return `&filter[where][or][${index}][id]=${item}`;
              })
              .join();
            return axios.get(`${config.urlApi}/adaptLevels?${queryAdap}`);
          }
          function getAdaptLevel() {

            if (adaptSubIds.length === 0)
              return ;

            const queryAdap = adaptSubIds
              .map((item, index) => {
                return `&filter[where][or][${index}][id]=${item}`;
              })
              .join();
            return axios.get(`${config.urlApi}/adaptSubLevels?${queryAdap}`);
          }

          function getThreatSubIds() {

            if (threatSubIds.length === 0)
              return ;

            const queryThreat = threatSubIds
              .map((item, index) => {
                return `&filter[where][or][${index}][id]=${item}`;
              })
              .join();
            return axios.get(`${config.urlApi}/threatSubTypes?${queryThreat}`);
          }

          function getThreatIds() {

            if (threatIds.length === 0)
              return ;

            const queryThreat = threatIds
              .map((item, index) => {
                return `&filter[where][or][${index}][id]=${item}`;
              })
              .join();
            return axios.get(`${config.urlApi}/threats?${queryThreat}`);
          }

          axios.all([getGuild()]).then(
            axios.spread(function(guild) {
              const guils = guild.data.map(item => {
                return item.type;
              });
              vue.guild = guils;

              // Both requests are now complete
            })
          );

          axios
            .all([
              getObjetive(),
              getAdaptLevelParent(),
              getAdaptLevel(),
              getThreatSubIds(),
              getThreatIds()
            ])
            .then(
              axios.spread(function(
                objetive,
                parentLevel,
                level,
                threat,
                mainThreat
              ) {
                const subthreatMain = threat.data.map(item => {
                  return item.subType;
                });
                const threatMain = mainThreat.data.map(item => {
                  return item.type;
                });
                const threats = [...threatMain, ...subthreatMain];
                const parentLevelFilter = parentLevel.data.map(item => {
                  return item.level;
                });
                const LevelFilter = level.data.map(item => {
                  return item.subLevel;
                });
                const levelF = [...parentLevelFilter, ...LevelFilter];
                vue.queryObjetive = objetive.data;
                vue.queryLevel = levelF;
                vue.queryThreat = threats;
              })
            );
        })
        .then(({ data }) => {})
        .catch(function(error) {});
    }
  },
  computed: {
    getExternalLinks() {
      const newArr = [];
      if (this.experiences && this.experiences.length > 0 && this.experiences.externalLink && this.experiences.externalLink.length > 0) {
        this.experiences.externalLink.map((it) => {
          if (it) {
            newArr.push(it)
          }
        })
        return newArr;
      }
      return []
    },
    index_ready() {
      if (this.index_view == true && this.detail_view == false) {
        return true;
      }
    },
    details_ready() {
      if (this.detail_view == true && this.index_view == false) {
        return false;
      }
    }
  }
};
</script>


<style>
body {
  overflow-x: hidden;
}
.text_desktop_header_index_container {
  width: 64%;
  line-height: 0.4;
  font-size: 25px;
  font-weight: bolder;
  margin: auto !important;
  position: relative;
  top: 40px;
}
.img_header {
  width: 100% !important;
  height: 480px !important;
}
.img_body {
  width: 100%;
  height: 250px !important;
  margin-bottom: 20px;
}
.img_body_container {
  width: 100%;
  margin: auto;
  margin-top: 20px;
}
.img_body_container > .row > .col-md-9 > p,
.img_body_container > .row > .col-md-12 > p {
  line-height: 0.4;
}
.btn-vermas {
  font-weight: bolder !important;
  color: #3366cc !important;
  text-decoration: underline !important;
  font-size: 20px;
}
.btn-vermas:hover {
  cursor: pointer;
}
.container_img_header {
  margin-top: -110px;
}
@media (max-width: 768px) {
  .img_header,
  .text_desktop_header_index_container {
    display: none;
  }
  .container_img_header {
    margin-top: 0px;
  }
}
</style>
